import { IAnalyticsExtConnectionSettings } from '../../../../../../settings/types/ISiteSettingsForSiteAdmin';
import { IGetItemsResult } from '../../../../types/IGetItemsResult';
import { TagRequest } from '../../../TagRequest';

export interface IGetAnalyticsExtConnectionSettingsResult extends IGetItemsResult {
  connectionList: IAnalyticsExtConnectionSettings[];
}

export class GetAnalyticsExtConnectionSettingsRequest extends TagRequest<{}, IGetAnalyticsExtConnectionSettingsResult> {
  constructor() {
    super('analyticsextensions', 'getAnalyticsExtensionsConnections', {});
  }
}
